import { useEffect, useRef } from 'react';
import styles from './styles.module.scss';
import useTranslation from 'hooks/useTranslation';

import check from 'assets/icons/Checkmark.svg';
import { CloseFilledCompIcon } from 'assets/icons';

import growth from 'assets/icons/Growth.svg';
import premium from 'assets/icons/Premium.svg';
import premiumPlus from 'assets/icons/PremiumPlus.svg';
import vip from 'assets/icons/VIP.svg';

function PackagesCompareContent() {
  const ref = useRef(null);

  const { getTranslation } = useTranslation('PACKAGES_COMPARE');
  const { t } = getTranslation();

  const renderCheckMark = (
    <img src={check} alt='check' key={'commerical'} width={19} height={19} />
  );

  const renderCrossMark = <CloseFilledCompIcon className={styles.cross_icon} />;

  const renderDiscountComparePrices = (
    packageType,
    beforeDiscountPriceText,
    hasDiscount
  ) => {
    const afterDiscountPriceText = t(
      `MODAL_${packageType}_ANNUAL_PRICE_AFTER_DISCOUNT`
    );

    return (
      <div>
        {hasDiscount ? (
          <>
            <span className={styles.after_discount_price}>
              {beforeDiscountPriceText}
            </span>
            <span>{afterDiscountPriceText}</span>
          </>
        ) : (
          <span>{afterDiscountPriceText}</span>
        )}
      </div>
    );
  };

  const TABLE_CONTENT = [
    // Features name column
    [...t('MODAL_FEATURES')],
    // Professional column
    [
      ...t('MODAL_COMMERICAL_FEATURES').map((item, index) => {
        if (item === '1') return renderCheckMark;

        if (item === '0') return renderCrossMark;

        // annual prices
        if (index === 2)
          return renderDiscountComparePrices('PROFESSIONAL', item, true);
        return item;
      }),
    ],
    // Commerical column
    [
      ...t('MODAL_COMMERICAL_FEATURES').map((item, index) => {
        if (item === '1') return renderCheckMark;

        if (item === '0') return renderCrossMark;

        // annual prices
        if (index === 2)
          return renderDiscountComparePrices('COMMERCIAL', item, true);
        return item;
      }),
    ],
    // Premuim column
    [
      ...t('MODAL_PREMIUM_FEATURES').map((item, index) => {
        if (item === '1') return renderCheckMark;

        if (item === '0') return renderCrossMark;

        // annual prices
        if (index === 2)
          return renderDiscountComparePrices('PREMIUM', item, true);
        return item;
      }),
    ],
    // premiumPlus column
    [
      ...t('MODAL_PREMIUM_PlUS_FEATURES').map((item, index) => {
        if (item === '1') return renderCheckMark;

        if (item === '0') return renderCrossMark;

        // annual prices
        if (index === 2)
          return renderDiscountComparePrices('PREMIUM_PLUS', item, true);
        return item;
      }),
    ],

    // VIP column
    [
      ...t('MODAL_VIP_FEATURES').map((item, index) => {
        if (item === '1') return renderCheckMark;

        if (item === '0') return renderCrossMark;

        // annual prices
        if (index === 2) return renderDiscountComparePrices('VIP', item, false);
        return item;
      }),
    ],
  ];

  useEffect(() => {
    const els = document.getElementsByClassName('modal__container');
    const modal__container__el = els[0];
    modal__container__el.classList.add(styles.compare_modal_styles);
  }, []);

  return (
    <div className={styles.packages_compare_modal_container}>
      <div ref={ref} className={styles.modal}>
        {/* <div className={styles.modal__heading}>
              <Image
                onClick={handleCloseModal}
                className={styles.modal__heading__close}
                src={close}
                alt="close"
                width={25}
                height={25}
              />
            </div> */}

        <div className={styles.modal__content}>
          {/* //? Features name column */}
          <div className={styles.fetaures}>
            <div className={styles.header__cell}>{TABLE_CONTENT[0][0]}</div>

            {TABLE_CONTENT[0].map((f, i) => {
              if (i > 0) {
                return (
                  <div
                    data-odd={i % 2 !== 0}
                    key={i}
                    className={styles.fetaures__cell}
                  >
                    {f}{' '}
                  </div>
                );
              }
            })}
          </div>

          {/* //? Growth column */}
          <div className={styles.free}>
            <div className={styles.header__cell}>
              <div className={styles.priceBox__title__emoji}>
                <img width={22} height={22} src={growth} alt={'feature'} />
              </div>
              <span className={styles.package_name}> {TABLE_CONTENT[2][0]} </span>
            </div>

            {TABLE_CONTENT[2].map((f, i) => {
              if (i > 0) {
                return (
                  <div
                    data-odd={i % 2 !== 0}
                    key={i}
                    className={styles.free__cell}
                  >
                    {f}{' '}
                  </div>
                );
              }
            })}
          </div>

          {/* //? Premium column */}
          <div className={styles.professional}>
            <div className={styles.header__cell}>
              <div className={styles.priceBox__title__emoji}>
                <img width={22} height={22} src={premium} alt={'feature'} />
              </div>
              <span className={styles.package_name}> {TABLE_CONTENT[3][0]} </span>
            </div>

            {TABLE_CONTENT[3].map((f, i) => {
              if (i > 0) {
                return (
                  <div
                    data-odd={i % 2 !== 0}
                    key={i}
                    className={styles.professional__cell}
                  >
                    {f}
                  </div>
                );
              }
            })}
          </div>

          {/* //? Premium Plus column */}
          <div className={styles.commercial}>
            <div className={styles.header__cell}>
              <div className={styles.priceBox__title__emoji}>
                <img width={22} height={22} src={premiumPlus} alt={'feature'} />
              </div>
              <span className={styles.package_name}> {TABLE_CONTENT[4][0]} </span>
            </div>

            {TABLE_CONTENT[4].map((f, i) => {
              if (i > 0) {
                return (
                  <div
                    data-odd={i % 2 !== 0}
                    key={i}
                    className={styles.commercial__cell}
                  >
                    {f}
                  </div>
                );
              }
            })}
          </div>

          <div className={styles.commercial}>
            <div className={styles.header__cell}>
              <div className={styles.priceBox__title__emoji}>
                <img width={22} height={22} src={vip} alt={'feature'} />
              </div>
              <span className={styles.package_name}> {TABLE_CONTENT[5][0]} </span>
            </div>

            {TABLE_CONTENT[5].map((f, i) => {
              if (i > 0) {
                return (
                  <div
                    data-odd={i % 2 !== 0}
                    key={i}
                    className={styles.commercial__cell}
                  >
                    {f}
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PackagesCompareContent;
